import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// REMOVED imports from 'react-icons'

// ADDED imports for your new local icon components
import HomeIcon from './HomeIcon';
import BriefcaseIcon from './BriefcaseIcon';
import ToolsIcon from './ToolsIcon';
import ProjectDiagramIcon from './ProjectDiagramIcon';
import EnvelopeIcon from './EnvelopeIcon';
import GithubIcon from './GitHubIcon';
import LeetcodeIcon from './LeetCodeIcon';

import './Navbar.css';
import netflixLogo from '../images/logo-3.png';
import blueImage from '../images/blue.png';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const profileImage = location.state?.profileImage || blueImage;

  const handleScroll = () => {
    setIsScrolled(window.scrollY > 80);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-left">
          <Link to="/" className="navbar-logo">
            <img src={netflixLogo} alt="Netflix" />
          </Link>
          <ul className="navbar-links">
            <li><Link to="/browse">Home</Link></li>
            <li><Link to="/work-experience">Professional</Link></li>
            <li><Link to="/skills">Skills</Link></li>
            <li><Link to="/projects">Projects</Link></li>
            <li><a href="https://github.com/Karan2916" target="_blank" rel="noopener noreferrer">GitHub</a></li>
            <li><a href="https://leetcode.com/u/8722645712/" target="_blank" rel="noopener noreferrer">LeetCode</a></li>
            <li><Link to="/contact-me">Hire Me</Link></li>
          </ul>
        </div>
        <div className="navbar-right">
          <div className="hamburger" onClick={toggleSidebar}>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <img src={profileImage} alt="Profile" className="profile-icon" onClick={() => { navigate('/browse') }} />
        </div>
      </nav>

      <div className={`sidebar-overlay ${isSidebarOpen ? 'open' : ''}`} onClick={closeSidebar}></div>

      {/* This sidebar now uses your new local icon components */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <img src={netflixLogo} alt="Netflix Logo" />
        </div>
        <ul>
          <li><Link to="/browse" onClick={closeSidebar}><HomeIcon /> Home</Link></li>
          <li><Link to="/work-experience" onClick={closeSidebar}><BriefcaseIcon /> Professional</Link></li>
          <li><Link to="/skills" onClick={closeSidebar}><ToolsIcon /> Skills</Link></li>
          <li><Link to="/projects" onClick={closeSidebar}><ProjectDiagramIcon /> Projects</Link></li>
          <li>
            <a href="https://github.com/Karan2916" target="_blank" rel="noopener noreferrer" onClick={closeSidebar}>
              <GithubIcon /> GitHub
            </a>
          </li>
          <li>
            <a href="https://leetcode.com/u/8722645712/" target="_blank" rel="noopener noreferrer" onClick={closeSidebar}>
              <LeetcodeIcon /> LeetCode
            </a>
          </li>
          <li><Link to="/contact-me" onClick={closeSidebar}><EnvelopeIcon /> Hire Me</Link></li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;